const initialState = {
    isTopBarVisible: true,
    isNavBarVisible: true,
    isSubBarVisible: false,
    scrollToTop: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case '@@redux-flash/ADD_MESSAGE':
        case 'SCROLL_TO_TOP_ENABLE':
            return {
                ...state,
                scrollToTop: true
            };
            
        case 'SCROLL_TO_TOP_DISABLE':
            return {
                ...state,
                scrollToTop: false
            };
            
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                isSubBarVisible: action.payload.pathname.startsWith('/workspace/')
            };
            
        case 'SHOW_TOP_BAR':
            return {
                ...state,
                isTopBarVisible: true
            };
            
        case 'HIDE_TOP_BAR':
            return {
                ...state,
                isTopBarVisible: false
            };
            
        case 'SHOW_NAV_BAR':
            return {
                ...state,
                isNavBarVisible: true
            };
            
        case 'HIDE_NAV_BAR':
            return {
                ...state,
                isNavBarVisible: false
            };
            
        case 'SHOW_SUB_BAR':
            return {
                ...state,
                isSubBarVisible: true
            };
            
        case 'HIDE_SUB_BAR':
            return {
                ...state,
                isSubBarVisible: false
            };
            
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/layout.js